import React from 'react';
import AgentDashboard from './AgentDashboard';

const OrientationDashboard: React.FC = () => {
  const agentConfig = {
    id: 'orientation',
    displayName: 'Orientation',
    icon: '/assets/logos/aldo-orientation.png',
    color: '#ec4899',
    description: 'New employee orientation assistant',
    hasTestResults: false
  };

  return <AgentDashboard agentConfig={agentConfig} />;
};

export default OrientationDashboard;

